import React from "react";
import values from "lodash/values";
import { RouteHandler } from "react-router";
import PageWithNav from "./page-with-nav.jsx";

import InlineButton from "./partials/inline-button.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../actions/EventBucketActions";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";
import UserActions from "../actions/UserActions.js";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [EventBucketStore, UserStore];
  }

  static getPropsFromStores() {
    let state = EventBucketStore.getState();
    state.isLoggedIn = UserStore.getState().isLoggedIn;
    return state;
  }

  static componentDidConnect(props) {
    EventBucketActions.fetchAll.defer();
    UserActions.fetchRoles.defer();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  componentWillReceiveProps(props) {
    if (!props.isLoggedIn) {
      this.props.history.push("/login");
    }
  }

  getStyles() {
    return {
      menuItem: {
        lineHeight: 1.3,
        padding: "16px 0",
        marginLeft: 40
      }
    };
  }

  render() {
    let menuItems = [
      { text: "Account", isSubheader: true },
      {
        route: "/account",
        text: "Manage account"
      },
      UserStore.hasPermission("manage_organization") && {
        route: "/organization",
        text: "Manage organization"
      },
      UserStore.getUserType() !== "content_creator" && {
        route: "/feedback",
        text: <span>Feature requests</span>
      },
      (
        UserStore.isGod() || 
        (
          UserStore.hasRole("admin") && 
          (
            UserStore.getUser().id === "5dae0d7c41443700308287c5" || 
            UserStore.getUser().id === "5a68bc8cf4a2de00148eedb0" ||
            UserStore.getUser().id === "632796a787711400538e66da"
          )
        )
      ) && {
        route: `/audit_log`,
        text: "Audit log"
      },
      UserStore.hasPermission("manage_billing") &&
        UserStore.getUserType() !== "content_creator" && {
          key: "financials",
          text: "Financials",
          isCollapsible: true,
          subitems: [
            {
              route: "/billing",
              text: <div style={{ marginLeft: 20 }}>Billing Hub</div>
            },
            {
              route: "/revenue_sharing",
              text: <div style={{ marginLeft: 20 }}>Revenue Sharing</div>
            }
          ]
        }
    ];

    if (UserStore.getUserType() === "content_creator") {
      menuItems = menuItems.concat([
        { isDivider: true },

        {
          text: <div>Creator</div>,
          isSubheader: true
        },
        {
          text: "Creator Hub",
          route: `/creator_hub`
        },

        { isDivider: true },

        { text: "Financials", isSubheader: true },
        {
          route: "/revenue_sharing",
          text: "Revenue Sharing"
        }
      ]);

      // Remove hasPermission=false items
      menuItems = menuItems.filter(i => i !== false);

      return (
        <PageWithNav menuItems={menuItems}>{this.props.children}</PageWithNav>
      );
    }

    menuItems = menuItems
      .concat([
        { isDivider: true },

        {
          text: (
            <div>
              Event buckets{" "}
              {UserStore.hasRole("admin") ? (
                <InlineButton
                  style={{ verticalAlign: 2, marginLeft: 5 }}
                  label="+ Create new"
                  onTouchTap={() =>
                    this.context.router.push("/event_buckets/new")
                  }
                />
              ) : null}
            </div>
          ),
          isSubheader: true
        }
      ])
      .concat(
        EventBucketStore.getEventBuckets().length === 0
          ? [
              {
                disabled: true,
                text: (
                  <i>
                    {this.props.isFetchingAll
                      ? "Loading your event buckets..."
                      : "No event buckets"}
                  </i>
                )
              }
            ]
          : []
      );

    let styles = this.getStyles(),
      { eventBucketId } = this.props.params,
      currentEventBucket = EventBucketStore.getEventBucketById(eventBucketId),
      currentRoutes = this.props.routes.map(function (r) {
        return r.name;
      });

    if (this.props.eventBuckets) {
      const activeEventBuckets = EventBucketStore.getEventBuckets().filter(
        b => b.mode !== "archived" || b.id === eventBucketId
      );
      const archivedEventBuckets = EventBucketStore.getEventBuckets().filter(
        b => b.mode === "archived"
      );

      menuItems = menuItems.concat(
        [].concat.apply(
          [],
          activeEventBuckets.map(b => {
            return [
              {
                route: `/event_buckets/${b.id}`,
                text: b.name
              }
            ].concat(
              eventBucketId !== b.id
                ? []
                : [
                    UserStore.hasPermission([
                      "edit_event_bucket",
                      "manage_configurator",
                      "manage_embed_wizard"
                    ]) && {
                      route: `/event_buckets/${b.id}/settings`,
                      text: (
                        <div
                          style={{
                            marginLeft: 20,
                            fontWeight: 500
                          }}
                        >
                          Settings
                        </div>
                      )
                    },
                    UserStore.hasPermission("view_analytics_list") && {
                      route: `/event_buckets/${b.id}/analytics`,
                      text: (
                        <div
                          style={{
                            marginLeft: 20,
                            fontWeight: 500
                          }}
                        >
                          Analytics
                        </div>
                      )
                    }
                  ]
                    .concat(
                      currentRoutes.indexOf("analytics") !== -1 ||
                        currentRoutes.indexOf("pass-analytics") !== -1 ||
                        currentRoutes.indexOf("attendee-analytics") !== -1 ||
                        currentRoutes.indexOf("geo-analytics") !== -1 ||
                        currentRoutes.indexOf("event-sales-analytics") !== -1 ||
                        currentRoutes.indexOf("event-passes-analytics") !==
                          -1 ||
                        currentRoutes.indexOf("sales-analytics") !== -1 ||
                        currentRoutes.indexOf("event-ticket-analytics") !==
                          -1 ||
                        currentRoutes.indexOf("streaming-analytics") !== -1 ||
                        currentRoutes.indexOf("recurring-pass-analytics") !== -1
                        ? [
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_attendee_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Attendee analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/attendees`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_event_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Event analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/events`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_standalone_ticket_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Standalone ticket analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/event_sales`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_pass_sales_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Pass sales analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/passes`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_pass_ticket_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Pass ticket analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/event_passes`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_recurring_pass_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Recurring pass analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/recurring_pass`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_geo_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>Geo analytics</div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/geo`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_streaming_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Streaming analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/streaming`
                            },
                            (UserStore.hasPermission("view_analytics") ||
                              UserStore.hasPermission(
                                "view_sales_analytics"
                              )) && {
                              text: (
                                <div style={styles.menuItem}>
                                  Sales analytics
                                </div>
                              ),
                              route: `/event_buckets/${b.id}/analytics/sales`
                            }
                          ]
                        : []
                    )
                    .concat(
                      [
                        UserStore.hasPermission("box_office") && {
                          route: `/event_buckets/${b.id}/box_office`,
                          text: (
                            <div
                              style={{
                                marginLeft: 20,
                                fontWeight: 500
                              }}
                            >
                              Box office
                            </div>
                          )
                        },
                        UserStore.hasPermission("view_film_list") && {
                          route: `/event_buckets/${b.id}/films`,
                          text: (
                            <div
                              style={{
                                marginLeft: 20,
                                fontWeight: 500
                              }}
                            >
                              Films
                            </div>
                          )
                        }
                      ]
                        .concat(
                          currentRoutes.indexOf("films") !== -1 ||
                            currentRoutes.indexOf("film-editor") !== -1 ||
                            currentRoutes.indexOf("new-film") !== -1 ||
                            currentRoutes.indexOf("bulk-import-films") !== -1
                            ? [
                                UserStore.hasPermission("edit_film") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new film
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/films/new`
                                },
                                UserStore.hasPermission(
                                  "bulk_import_films"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Bulk import films
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/bulk_import_films`
                                }
                              ]
                            : []
                        )
                        .concat([
                          b.enable_virtual_festival &&
                            (UserStore.hasPermission(
                              "manage_virtual_festival"
                            ) ||
                              UserStore.hasPermission(
                                "view_virtual_event_list"
                              )) && {
                              route: `/event_buckets/${b.id}/virtual_festival`,
                              text: (
                                <div
                                  style={{
                                    marginLeft: 20,
                                    fontWeight: 500
                                  }}
                                >
                                  Virtual screenings
                                </div>
                              )
                            }
                        ])
                        .concat(
                          currentRoutes.indexOf("virtual-festival") !== -1 ||
                            currentRoutes.indexOf(
                              "virtual-festival-event-editor"
                            ) !== -1 ||
                            currentRoutes.indexOf("virtual-festival-events") !==
                              -1 ||
                            currentRoutes.indexOf(
                              "virtual-festival-bulk-import-events"
                            ) !== -1
                            ? [
                                UserStore.hasPermission(
                                  "manage_virtual_festival"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new virtual screening
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/events/new?virtual=true`
                                },
                                UserStore.hasPermission(
                                  "manage_virtual_festival"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Livestreaming hub
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/virtual_festival/live`
                                },
                                UserStore.hasPermission(
                                  "manage_virtual_festival"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Bulk import screenings
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/virtual_festival/bulk_import_events`
                                }
                                // TOO UNWIELDY
                                // ].concat(b.events.map(e => {
                                //   return {
                                //     text: <div style={styles.menuItem}>{e.name}</div>,
                                //     route: 'event',
                                //     routeParams: { eventBucketId: b.id, eventId: e.id }
                                //   }
                                // })) : []).concat([
                              ]
                            : []
                        )

                        .concat([
                          false /* DISABLED */ &&
                            UserStore.hasPermission("edit_event") &&
                            currentEventBucket &&
                            currentEventBucket.class === "yearround" && {
                              route: `/event_buckets/${b.id}/scheduler`,
                              text: (
                                <div
                                  style={{
                                    marginLeft: 20,
                                    fontWeight: 500
                                  }}
                                >
                                  Scheduler
                                </div>
                              )
                            }
                        ])
                        .concat([
                          UserStore.hasPermission(
                            "view_physical_event_list"
                          ) && {
                            route: `/event_buckets/${b.id}/events`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Physical events
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("event") !== -1 ||
                            currentRoutes.indexOf("event-editor") !== -1 ||
                            currentRoutes.indexOf("events") !== -1 ||
                            currentRoutes.indexOf("bulk-import-events") !== -1
                            ? [
                                UserStore.hasPermission(
                                  "edit_physical_event"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new event
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/events/new`
                                },
                                UserStore.hasPermission(
                                  "bulk_import_events"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Bulk import events
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/bulk_import_events`
                                }
                                // TOO UNWIELDY
                                // ].concat(b.events.map(e => {
                                //   return {
                                //     text: <div style={styles.menuItem}>{e.name}</div>,
                                //     route: 'event',
                                //     routeParams: { eventBucketId: b.id, eventId: e.id }
                                //   }
                                // })) : []).concat([
                              ]
                            : []
                        )
                        .concat([
                          (UserStore.hasPermission("view_pass_bucket_list") ||
                            UserStore.hasPermission("print_pass_labels") ||
                            UserStore.hasPermission("box_office")) && {
                            route: `/event_buckets/${b.id}/pass_buckets`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Pass buckets
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("pass-buckets") !== -1 ||
                            currentRoutes.indexOf("pass-bucket") !== -1 ||
                            currentRoutes.indexOf("pass-bucket-editor") !==
                              -1 ||
                            currentRoutes.indexOf("pass-label-printer") !==
                              -1 ||
                            currentRoutes.indexOf("bulk-import-passes") !==
                              -1 ||
                            currentRoutes.indexOf("pass-bucket-analytics") !==
                              -1 ||
                            currentRoutes.indexOf("check-in") !== -1
                            ? [
                                UserStore.hasPermission(
                                  "print_pass_labels"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Pass label printer
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/pass_label_printer`
                                },
                                UserStore.hasPermission(
                                  "bulk_import_passes"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Bulk import passes
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/bulk_import_passes`
                                },
                                UserStore.hasPermission("box_office") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Check in passholders
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/check_in`
                                }
                                // TOO UNWIELDY
                                // { isDivider: true, inset: true }
                                // ].concat(
                                //   b.pass_buckets.map(p => {
                                //   return UserStore.hasPermission('view_pass_bucket') && {
                                //     text: <div style={styles.menuItem}>{p.name}</div>,
                                //     route: `/event_buckets/${b.id}/pass_buckets/${p.id}`
                                //   }
                                // })) : []).concat([
                              ]
                            : []
                        )
                        .concat([
                          UserStore.hasPermission("view_coupon_list") && {
                            route: `/event_buckets/${b.id}/coupons`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Discounts
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("coupon") !== -1 ||
                            currentRoutes.indexOf("coupons") !== -1 ||
                            currentRoutes.indexOf("coupon-editor") !== -1
                            ? [
                                UserStore.hasPermission("edit_coupon") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new discount
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/coupons/new`
                                }
                                // TOO UNWIELDY
                                // ].concat(
                                //   b.coupons.map(c => {
                                //   return {
                                //     text: <div style={styles.menuItem}>{c.name}</div>,
                                //     route: 'coupon',
                                //     routeParams: { eventBucketId: b.id, couponId: c.id }
                                //   }
                                // })) : []).concat([
                              ]
                            : []
                        )
                        .concat([
                          UserStore.hasPermission("manage_venues") && {
                            route: `/event_buckets/${b.id}/venues`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Venues
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("venue") !== -1 ||
                            currentRoutes.indexOf("venues") !== -1
                            ? [
                                UserStore.hasPermission("manage_venues") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new venue
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/venues/new`
                                }
                                // TOO UNWIELDY
                                // ].concat(
                                //   b.venues.map(v => {
                                //   return {
                                //     text: <div style={styles.menuItem}>{v.name}</div>,
                                //     route: 'coupon',
                                //     routeParams: { eventBucketId: b.id, venueId: v.id }
                                //   }
                                // })) : []).concat([
                              ]
                            : []
                        )
                        .concat([
                          UserStore.hasPermission("manage_tags") && {
                            route: `/event_buckets/${b.id}/tags`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Tags
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("tag") !== -1 ||
                            currentRoutes.indexOf("tags") !== -1
                            ? [
                                UserStore.hasPermission("manage_tags") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new tag
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/tags/new`
                                }
                                // TOO UNWIELDY
                                // ].concat(
                                //   b.venues.map(v => {
                                //   return {
                                //     text: <div style={styles.menuItem}>{v.name}</div>,
                                //     route: 'coupon',
                                //     routeParams: { eventBucketId: b.id, venueId: v.id }
                                //   }
                                // })) : []).concat([
                              ]
                            : []
                        )
                        .concat([
                          false && // KIOSKS CURRENTLY DISABLED
                            UserStore.hasPermission("manage_kiosks") && {
                              route: `/event_buckets/${b.id}/kiosks`,
                              text: (
                                <div
                                  style={{
                                    marginLeft: 20,
                                    fontWeight: 500
                                  }}
                                >
                                  Kiosks
                                </div>
                              )
                            }
                        ])
                        .concat(
                          currentRoutes.indexOf("kiosk") !== -1 ||
                            currentRoutes.indexOf("kiosks") !== -1
                            ? [
                                // UserStore.hasPermission('manage_kiosks') && {
                                //   text: <div style={styles.menuItem}>Create new kiosk</div>,
                                //   route: `/event_buckets/${b.id}/kiosks/new`
                                // }
                                // TOO UNWIELDY
                                // ].concat(
                                //   b.kiosks.map(k => {
                                //   return {
                                //     text: <div style={styles.menuItem}>{k.name}</div>,
                                //     route: 'kiosk',
                                //     routeParams: { eventBucketId: b.id, kioskId: k.id }
                                //   }
                                // })) : [])
                              ]
                            : []
                        )
                        .concat([
                          UserStore.hasPermission("manage_mailings") && {
                            route: `/event_buckets/${b.id}/mailings`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Mailings
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("mailing") !== -1 ||
                            currentRoutes.indexOf("mailings") !== -1
                            ? [
                                UserStore.hasPermission("manage_mailings") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new mailing
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/mailings/new`
                                }
                              ]
                            : []
                        )
                        .concat(
                          b.enable_balloting
                            ? UserStore.hasPermission("manage_balloting") ||
                              UserStore.hasPermission("view_balloting")
                              ? [
                                  {
                                    route: `/event_buckets/${b.id}/balloting`,
                                    text: (
                                      <div
                                        style={{
                                          marginLeft: 20,
                                          fontWeight: 500
                                        }}
                                      >
                                        Balloting
                                      </div>
                                    )
                                  }
                                ]
                              : UserStore.hasPermission("app_balloting")
                              ? [
                                  {
                                    route: `/event_buckets/${b.id}/balloting/app`,
                                    text: (
                                      <div
                                        style={{
                                          marginLeft: 20,
                                          fontWeight: 500
                                        }}
                                      >
                                        Balloting
                                      </div>
                                    )
                                  }
                                ]
                              : []
                            : []
                        )
                        .concat([
                          UserStore.hasPermission("manage_external_syncs") && {
                            route: `/event_buckets/${b.id}/external_syncs`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                External syncs
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("external-sync") !== -1 ||
                            currentRoutes.indexOf("external-syncs") !== -1
                            ? [
                                UserStore.hasPermission(
                                  "manage_external_syncs"
                                ) && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new external sync
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/external_syncs/new`
                                }
                              ]
                            : []
                        )
                        .concat([
                          UserStore.hasPermission("view_item_bucket") && {
                            route: `/event_buckets/${b.id}/item_buckets`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Item buckets
                              </div>
                            )
                          }
                        ])
                        .concat(
                          currentRoutes.indexOf("item-bucket") !== -1 ||
                            currentRoutes.indexOf("item-buckets") !== -1 ||
                            currentRoutes.indexOf("item-bucket-editor") !== -1
                            ? [
                                UserStore.hasPermission("edit_item_bucket") && {
                                  text: (
                                    <div style={styles.menuItem}>
                                      Create new item bucket
                                    </div>
                                  ),
                                  route: `/event_buckets/${b.id}/item_buckets/new`
                                }
                              ]
                            : []
                        )
                        .concat([
                          UserStore.hasPermission([
                            "manage_people",
                            "view_people"
                          ]) && {
                            route: `/event_buckets/${b.id}/people`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                People
                              </div>
                            )
                          },
                          UserStore.hasPermission([
                            "manage_orders",
                            "view_orders"
                          ]) && {
                            route: `/event_buckets/${b.id}/orders`,
                            text: (
                              <div
                                style={{
                                  marginLeft: 20,
                                  fontWeight: 500
                                }}
                              >
                                Orders
                              </div>
                            )
                          }
                        ])
                    )
            );
          })
        )
      );

      if (archivedEventBuckets.length) {
        menuItems = menuItems.concat([
          {
            key: "archive",
            text: "Archive",
            isCollapsible: true,
            subitems: archivedEventBuckets.map(b => {
              return {
                route: `/event_buckets/${b.id}`,
                text: (
                  <div
                    style={{
                      marginLeft: 20
                    }}
                  >
                    {b.name}
                  </div>
                )
              };
            })
          }
        ]);
      }
    }

    if (
      UserStore.hasPermission("view_analytics") ||
      UserStore.hasRole("manager")
    ) {
      menuItems = menuItems.concat(
        [{ isDivider: true }, { text: "Global", isSubheader: true }]
          .concat([
            {
              route: "/people",
              text: "All customers"
            }
          ])
          .concat([
            (currentRoutes.indexOf("bulk-import-people") !== -1 ||
              currentRoutes.indexOf("people") !== -1) && {
              route: `/bulk_import_people`,
              text: (
                <div
                  style={{
                    marginLeft: 20
                  }}
                >
                  Bulk import people
                </div>
              )
            }
          ])
          .concat([
            {
              route: "/orders",
              text: "All orders"
            },
            UserStore.hasPermission("view_global_reports") && {
              route: "/reports",
              text: "Global reports"
            },
            UserStore.isGod() && {
              route: "/scheduled_reports",
              text: (
                <span>
                  Scheduled reports{" "}
                  <InlineNoticeLabel
                    style={{ marginLeft: 5, fontWeight: "bold" }}
                    label="God beta"
                  />
                </span>
              )
            }
          ])
      );
    }

    if (
      UserStore.hasPermission("manage_virtual_festival") ||
      UserStore.hasPermission("manage_scanner") ||
      UserStore.hasPermission("setup_scanner")
    ) {
      menuItems = menuItems.concat([
        !UserStore.hasPermission("view_analytics") && { isDivider: true },
        {
          key: "more",
          text: "More",
          isCollapsible: true,
          subitems: [
            UserStore.hasPermission("manage_virtual_festival") && {
              text: (
                <div
                  style={{
                    marginLeft: 20
                  }}
                >
                  Creator Hub
                </div>
              ),
              route: `/creator_hub`
            },
            (UserStore.hasPermission("manage_scanner") ||
              UserStore.hasPermission("setup_scanner")) && {
              route: "/account/scanner",
              text: (
                <div
                  style={{
                    marginLeft: 20
                  }}
                >
                  Scanner setup
                </div>
              )
            },
            UserStore.hasPermission("manage_scanner") && {
              route: "/shop",
              text: (
                <div
                  style={{
                    marginLeft: 20
                  }}
                >
                  Hardware shop
                </div>
              )
            }
          ].filter(x => !!x)
        }
      ]);
    }

    if (UserStore.isGod()) {
      menuItems = menuItems.concat([
        { isDivider: true },
        {
          route: "/god",
          text: "🕊"
        },
        UserStore.isBillingGod() && {
          route: "/god/invoicing_hub",
          text: "🦆"
        },
        {
          route: "/god_orders",
          text: "💸"
        },
        {
          route: "/organization_health",
          text: "🩺"
        },
        {
          route: "/god/revenue",
          text: "📈"
        },
        {
          route: "/god/streams",
          text: "📺"
        },
        {
          route: "/god/upcoming_events",
          text: "📅"
        },
        {
          route: "/god/lookup",
          text: "🔎"
        }
      ]);
    }

    // Remove hasPermission=false items
    menuItems = menuItems.filter(i => i !== false);

    return (
      <PageWithNav menuItems={menuItems}>{this.props.children}</PageWithNav>
    );
  }
}

export default connectToStores(Dashboard);



// WEBPACK FOOTER //
// ./src/app/components/dashboard.jsx